module.exports = __webpack_public_path__ + "img/AT0000002572491.e18630a7.png";